import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function ArticleCard({ article, size = "md", index = 0 }) {
  const isLarge = size === "lg";
  return (
    <Link
      to={`/article/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block border border-white/10 bg-card hover:border-signal transition-colors animate-rise"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className={`relative overflow-hidden ${isLarge ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
        <img
          src={article.image}
          alt={article.title}
          className="img-treatment w-full h-full object-cover"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest bg-signal text-white px-2 py-1">
          {article.category}
        </span>
      </div>
      <div className="p-5">
        <h3
          className={`font-display font-semibold tracking-tight leading-[1.05] group-hover:text-signal transition-colors ${
            isLarge ? "text-2xl md:text-3xl" : "text-lg"
          }`}
        >
          {article.title}
        </h3>
        {isLarge && (
          <p className="text-muted-foreground text-sm mt-3 leading-relaxed line-clamp-2">
            {article.dek}
          </p>
        )}
        <div className="flex items-center justify-between mt-4">
          <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            {article.author} · {article.read_time}m
          </span>
          <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-signal transition-colors" />
        </div>
      </div>
    </Link>
  );
}
